
import React from "react";
import { createBrowserRouter, RouterProvider, LoaderFunction, ActionFunction } from "react-router-dom";

const routes = {
  "path": "/",
  "children": [
    {
      "path": "error",
      "lazy": async () => import('./pages/error.tsx').then(res => {  return ({    Component: res.default,    loader: 'loader' in res && typeof res.loader === 'function' ? res.loader as LoaderFunction : undefined,    action: 'action' in res && typeof res.action === 'function' ? res.action as ActionFunction : undefined,    errorElement: 'ErrorBoundary' in res && res.ErrorBoundary !== undefined ? React.createElement(res.ErrorBoundary as unknown as React.FC) : undefined  })})
    },
    {
      "path": "",
      "children": [
        {
          "path": ":tenantSlug",
          "children": [
            {
              "index": true,
              "lazy": async () => import('./pages/root/_tenantSlug/index.tsx').then(res => {  return ({    Component: res.default,    loader: 'loader' in res && typeof res.loader === 'function' ? res.loader as LoaderFunction : undefined,    action: 'action' in res && typeof res.action === 'function' ? res.action as ActionFunction : undefined,    errorElement: 'ErrorBoundary' in res && res.ErrorBoundary !== undefined ? React.createElement(res.ErrorBoundary as unknown as React.FC) : undefined  })})
            }
          ]
        },
        {
          "index": true,
          "lazy": async () => import('./pages/root/index.tsx').then(res => {  return ({    Component: res.default,    loader: 'loader' in res && typeof res.loader === 'function' ? res.loader as LoaderFunction : undefined,    action: 'action' in res && typeof res.action === 'function' ? res.action as ActionFunction : undefined,    errorElement: 'ErrorBoundary' in res && res.ErrorBoundary !== undefined ? React.createElement(res.ErrorBoundary as unknown as React.FC) : undefined  })})
        }
      ],
      "lazy": async () => import('./pages/root/layout.tsx').then(res => {  return ({    Component: res.default,    loader: 'loader' in res && typeof res.loader === 'function' ? res.loader as LoaderFunction : undefined,    action: 'action' in res && typeof res.action === 'function' ? res.action as ActionFunction : undefined,    errorElement: 'ErrorBoundary' in res && res.ErrorBoundary !== undefined ? React.createElement(res.ErrorBoundary as unknown as React.FC) : undefined  })})
    }
  ],
  "lazy": async () => import('./pages/root.tsx').then(res => {  return ({    Component: res.default,    loader: 'loader' in res && typeof res.loader === 'function' ? res.loader as LoaderFunction : undefined,    action: 'action' in res && typeof res.action === 'function' ? res.action as ActionFunction : undefined,    errorElement: 'ErrorBoundary' in res && res.ErrorBoundary !== undefined ? React.createElement(res.ErrorBoundary as unknown as React.FC) : undefined  })})
}

const router = createBrowserRouter([routes], { basename: "/" });

const Router: React.FC = () => {
  return <RouterProvider router={router} />;
};
export default Router
